import Vue                    from "vue"
import Vuex                   from "vuex"
import auth                   from "./modules/auth"
import localize               from "./modules/localize"
import messageList              from "./modules/messageList"
import tenant                 from "./modules/tenant"
import recentComponentStore   from "./modules/recentComponentStore"
import partSearchResultStore  from "./modules/partSearchResultStore"
import cart                   from "./modules/cart"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    localize,
    messageList,
    tenant,
    recentComponentStore,
    partSearchResultStore,
    cart
  }
})
